import { Typography } from "@circle-react-shared/uikit/Typography";
import type { Plan } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import { annualDiscountPercentage } from "@/react/helpers/planHelpers";

export const AnnualDiscount = ({ plan }: { plan: Plan }) => {
  if (!plan.annual_discount_amount_with_currency) return null;

  return (
    <Typography.BodyXs weight="light">
      {t(
        "pricing_plans.plan_settings.plan_selection.plan_selector.annual_amount",
        {
          dollar_amount: plan.annual_base_amount_with_currency,
        },
      )}
      <span className="text-green-success-dark ml-1 font-semibold">
        {plan.fetch_discount
          ? t(
              "pricing_plans.plan_settings.plan_selection.plan_selector.saved_dollar_amount_with_percentage",
              {
                dollar_amount: plan.annual_discount_amount_with_currency,
                percentage: annualDiscountPercentage(plan),
              },
            )
          : t(
              "pricing_plans.plan_settings.plan_selection.plan_selector.saved_dollar_amount",
              {
                dollar_amount: plan.annual_discount_amount_with_currency,
              },
            )}
      </span>
    </Typography.BodyXs>
  );
};
